export default "__VITE_ASSET__BjfDyfI7__"